export const ERROR_BOUNDARY_REDIRECT_PATH = "errorBoundaryRedirectPath";

/**
 * Save data to localStorage
 * @param {string} key - The key to store data under
 * @param {any} value - The value to store
 * @returns {void}
 */
export const setLocalStorage = (key, value) => {
  try {
    const serializedValue = typeof value === "object" ? JSON.stringify(value) : value;
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error setting localStorage:", error);
  }
};

/**
 * Retrieve data from localStorage
 * @param {string} key - The key to retrieve data from
 * @param {any} defaultValue - Default value if key doesn't exist
 * @returns {any} The stored value or defaultValue if not found
 */
export const getLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, return as is if not valid JSON
    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  } catch (error) {
    console.error("Error getting localStorage:", error);
    return defaultValue;
  }
};

/**
 * Remove data from localStorage
 * @param {string} key - The key to remove
 * @returns {void}
 */
export const removeLocalStorage = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing localStorage:", error);
  }
};

/**
 * Clear all data from localStorage
 * @returns {void}
 */
export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
};

/**
 * LocalStorage utility function dictionary
 */
export const localStorageUtils = {
  set: setLocalStorage,
  get: getLocalStorage,
  remove: removeLocalStorage,
  clear: clearLocalStorage,
};

export default localStorageUtils;
